import store from '@/store'
import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Register from '../views/Register.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import AdminDashboard from '../views/AdminDashboard.vue'
import Reminders from '../views/Reminders.vue'
import addReminder from '../views/addReminder'
import ReviewReminder from '../views/ReviewReminder'
import Clients from '../views/Clients'
import ClientDetails from '../views/ClientDetails'
import ClientWrapper from '../views/ClientsWrapper'
import Account from '../views/Account'
import Settings from '../views/Settings'
import ForgotPassword from '../views/ForgotPassword'
import UpdatePassword from '../views/UpdatePassword'
// import router from '@/router';


// const routes = 

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresUnauth: true,
      },
    },
  
    {
      path: '/register',
      name: 'register',
      component: Register
    },
  
    {
      path: '/login',
      name: 'login',
      component: Login
    },
  
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
  
    {
      path: '/reminders',
      name: 'reminders',
      component: Reminders,
      meta: {
        requiresAuth: true,
      },
    },
  
  
    {
      path: '/add-reminder',
      name: 'add-reminder',
      component: addReminder,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/review-reminder',
      name: 'review-reminder',
      component: ReviewReminder,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: '/account',
      name: 'account',
      component: Account,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword,
    },

    {
      path: '/update-password/:token',
      name: 'update-password',
      component: UpdatePassword,
    },
  

    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: {
        requiresAuth: true,
      },
    },
  
    {
      path: '/admin-dashboard',
      name: 'admin-dashboard',
      component: AdminDashboard,
      meta: {
        requiresAuth: true,
      },
    },
  
    {
      path: '/clients',
      name: 'clients',
      component: ClientWrapper,
      children: [
        {
          path: '/clients',
          name: 'clients',
          component: Clients,
          meta: {
            requiresAuth: true,
          },
        },
  
        {
          path: '/client-details/:id',
          name: 'clients-details',
          component: ClientDetails,
          meta: {
            requiresAuth: true,
          },
        },
      ]
    },
  
  
    
    // {
    //   path: '/',
    //   name: 'home',
    //   component: HomeView
    // },
    // {
    //   path: '/about',
    //   name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    // }
  ],
  scrollBehavior(to, from, savedPosition){
    return{top: 0,
            behavior: 'smooth'}
  }
})


router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresUnauth = to.matched.some(
    (record) => record.meta.requiresUnauth
  );

  const isAuth = store.state.user;

  if (requiresAuth && !isAuth) next("/login");
  else if (requiresUnauth && isAuth) next();
  else next();
})


export default router
